import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ShoppingBag01 = function ShoppingBag01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.52 2.64 3.96 4.72c-.309.412-.4635.618-.4599.7904a.5.5 0 0 0 .1916.3833C3.8276 6 4.085 6 4.6 6h14.8c.515 0 .7725 0 .9083-.1063a.5.5 0 0 0 .1916-.3833c.0036-.1724-.1509-.3784-.4599-.7904l-1.56-2.08m-12.96 0c.176-.2347.264-.352.3755-.4366a1 1 0 0 1 .3299-.165C6.36 2 6.5067 2 6.8 2h10.4c.2933 0 .44 0 .5746.0385.1192.034.2311.09.3299.1649.1115.0846.1995.202.3755.4366m-12.96 0L3.64 5.1467c-.2375.3166-.3562.4749-.4405.6492a2 2 0 0 0-.1623.487C3 6.473 3 6.671 3 7.0668V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 22 5.08 22 6.2 22h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.4802 21 19.9201 21 18.8V7.0667c0-.3958 0-.5937-.0372-.7837a2 2 0 0 0-.1623-.487c-.0843-.1744-.203-.3327-.4405-.6493L18.48 2.64M16 10a4 4 0 0 1-1.1716 2.8284 3.9996 3.9996 0 0 1-5.6568 0A4 4 0 0 1 8 10"
    })
  }));
};
export default ShoppingBag01;